// extracted by mini-css-extract-plugin
export default {"list":"_66chV","okIcon":"_1SCVW"};